module.exports = __webpack_public_path__ + "img/portrait-102.0901d90b.jpg";